<template>
  <div>
    <panel-description
      :paymentMethodName="paymentMethodName"
      :virtualAccountNumber="virtualAccountNumber"
      :viewMybookingUrl="viewMybookingUrl"
      :price="price"
      :orderNumber="orderNumber"
    />
    <div class="container py-3" id="checkout-thankyou">
      <countdown :paymentDueDiff="paymentDueDiff" class="mt-4"></countdown>
      <panel-steps
        :content="content"
        :viewMybookingUrl="viewMybookingUrl"
        v-if="content"
      ></panel-steps>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Countdown from '@/components/how-to-pay/partials/countdown';
import PanelDescription from '@/components/how-to-pay/partials/panel-description';
import PanelSteps from '@/components/how-to-pay/partials/panel-steps';
export default {
  name: 'permata',
  props: [
    'paymentMethodName',
    'price',
    'virtualAccountNumber',
    'viewMybookingUrl',
    'orderNumber',
    'paymentDueDiff',
  ],
  components: {
    PanelDescription,
    Countdown,
    PanelSteps,
  },
  data: () => ({
    content: null,
  }),
  computed: {
    ...mapState({
      bookingOrder: (state) => state.v2.booking.bookingOrder,
    }),
  },
  mounted() {
    this.content = {
      tabs: [
        {
          title: 'via ATM Mandiri / Bersama',
          steps: [
            this.$t('booking.guide.mandiri.msg1'),
            this.$t('booking.guide.mandiri.msg2'),
            this.$t('booking.guide.mandiri.msg3'),
            `${this.$t('booking.guide.mandiri.msg4')} ${this.virtualAccountNumber} ${this.$t(
              'booking.guide.mandiri.msg4_2',
            )}`,
            this.$t('booking.guide.mandiri.msg5'),
            this.$t('booking.guide.mandiri.msg6'),
            this.$t('booking.guide.mandiri.msg7'),
          ],
        },
        {
          title: 'via ATM BCA / Prima',
          steps: [
            this.$t('booking.guide.BCA.msg1'),
            this.$t('booking.guide.BCA.msg2'),
            this.$t('booking.guide.BCA.msg3'),
            this.$t('booking.guide.BCA.msg4'),
            this.$t('booking.guide.BCA.msg5'),
            `${this.$t('booking.guide.BCA.msg6')} ${this.virtualAccountNumber} ${this.$t(
              'booking.guide.BCA.msg6_5',
            )}`,
            this.$t('booking.guide.BCA.msg7'),
          ],
        },
        {
          title: 'via ATM Permata / Alto',
          steps: [
            this.$t('booking.guide.permata.msg1'),
            this.$t('booking.guide.permata.msg2'),
            this.$t('booking.guide.permata.msg3'),
            this.$t('booking.guide.permata.msg4'),
            `${this.$t('booking.guide.permata.msg5')} ${this.virtualAccountNumber} ${this.$t(
              'booking.guide.permata.msg5_5',
            )}`,
            this.$t('booking.guide.permata.msg6'),
            this.$t('booking.guide.permata.msg7'),
          ],
        },
      ],
    };
  },
};
</script>

<style scoped></style>
